import React, { Component } from 'react';

class Dashboard extends Component {

    render() {
        return (
            <div className="pos-page">
                <h2>POS Dashboard</h2>

                <div className="dashboard-cards">

                    <div className="card">
                        <h3>Today's Sales</h3>
                        <p>₹ 25,000</p>
                    </div>

                    <div className="card">
                        <h3>Orders</h3>
                        <p>120</p>
                    </div>

                    <div className="card">
                        <h3>Tables Occupied</h3>
                        <p>15 / 40</p>
                    </div>

                </div>

            </div>
        );
    }
}

export default Dashboard;